var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnyExpertLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9C8.873 9 10.57 9.62 11.815 10.487C12.998 11.312 14 12.538 14 13.857C14 14.581 13.691 15.181 13.204 15.627C12.746 16.048 12.148 16.321 11.532 16.507C10.301 16.88 8.68 17 7 17C5.32 17 3.699 16.88 2.468 16.507C1.852 16.321 1.254 16.048 0.795 15.627C0.31 15.182 0 14.582 0 13.858C0 12.539 1.002 11.313 2.185 10.488C3.43 9.62 5.127 9 7 9ZM7 11C5.56 11 4.257 11.48 3.33 12.127C2.341 12.817 2 13.519 2 13.857C2 14.161 2.352 14.351 2.672 14.471L2.877 14.541L3.047 14.593C3.987 14.877 5.367 15 7 15C8.508 15 9.799 14.895 10.728 14.656L11.032 14.569L11.222 14.509C11.565 14.392 12 14.195 12 13.857C12 13.519 11.659 12.817 10.67 12.127C9.744 11.481 8.44 11 7 11ZM7 0C8.06087 0 9.07828 0.421427 9.82843 1.17157C10.5786 1.92172 11 2.93913 11 4C11 5.06087 10.5786 6.07828 9.82843 6.82843C9.07828 7.57857 8.06087 8 7 8C5.93913 8 4.92172 7.57857 4.17157 6.82843C3.42143 6.07828 3 5.06087 3 4C3 2.93913 3.42143 1.92172 4.17157 1.17157C4.92172 0.421427 5.93913 0 7 0ZM7 2C6.46957 2 5.96086 2.21071 5.58579 2.58579C5.21071 2.96086 5 3.46957 5 4C5 4.53043 5.21071 5.03914 5.58579 5.41421C5.96086 5.78929 6.46957 6 7 6C7.53043 6 8.03914 5.78929 8.41421 5.41421C8.78929 5.03914 9 4.53043 9 4C9 3.46957 8.78929 2.96086 8.41421 2.58579C8.03914 2.21071 7.53043 2 7 2Z",
    fill: "#363636"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnyExpertLogo);
export default __webpack_public_path__ + "static/media/any_expert_logo.3782b05d111a9092c6f181b52cd7fa87.svg";
export { ForwardRef as ReactComponent };